import { IWykrojnikKoszt  } from "./costdetail/IWykrojnikiCostSvc"; 
import { IKosztRobSur, KosztRobSur } from "./costdetail/IWykrojnikiCostSvc";
import { Licz } from "./costdetail/Log";
import { IWykrojnik } from "./IWykrojnik";
import { IWykrojnikRow } from "./IWykrojnikRow";
import { IWykrojnikParams } from "./params/IWykrojnikParams";

export class WykrojnikRow implements IWykrojnikRow, IWykrojnikKoszt {

    _id: any;
    parent_id: any;
    version: number = 0;
    type: string = "wykr";
    idn?: string = "";
    _err: any={};

    kalk_id: number | undefined;

    x:number = 0
    x1:number = 0
    y:number = 0
    y1:number = 0
    banda:number = 0
    ux:number = 0
    uy:number = 0
    szerokosc:number = 0
    zeby:number = 0
    R:number = 0

    ksztalt: string='P';
    wykorzystanie:number = 0
    is_best: boolean = true

    numer:number = 0;
    naklad:number = 0;
    mb:number = 0;
    msgs: string[]=[];
    origin:string=''

    koszt_przezbr:IKosztRobSur=new KosztRobSur();
    koszt_zmiany:IKosztRobSur=new KosztRobSur();
    koszt_1K:IKosztRobSur=new KosztRobSur();

    faktor_czasu_druku=0.0;
    faktor_czasu_przezbrojenia=0.0
    faktor_czasu_zmiany=0.0
    faktor_mb=0.0;
    

    min_koszt_rob=0;
    koszt_nakladu=0
    mb_nakladu=0;
    mkw_nakladu=0;


    nazwa: string="";
    miejsce:string="";
    opis:string="";
    raport: number|undefined;
    uwagi: string="";
    dostepnosc: string="";

    w23_mat_wie_pap: string = "";
    w24_mat_wie_fol: string = "";
    w25_podklad_pap: string = "";
    w26_podklad_fol: string = "";
    w27_podklad_iml: string = "";
    w28_min_gr_podkl: number|undefined;
    w29_max_gr_podkl: number|undefined;

    mb_przezbr:number = 0
    mb_1K:number = 0
    mkw_przezbr:number = 0
    mkw_1K:number = 0


    public init(w: any) {

        this._id = w._id;
        this.kalk_id = w.kalk_id;

        this.x = w.x;
        this.x1 = w.x1
        this.y = w.y
        this.y1 = w.y1
        this.banda = w.banda
        this.ux = w.ux
        this.uy = w.uy
        this.szerokosc = w.szerokosc
        this.zeby = w.zeby

        this.R = w.R

        this.ksztalt = w.ksztalt
        this.wykorzystanie = w.wykorzystanie;
        this.is_best = w.is_best

        this.numer = w.numer
        if (!this.numer) this.numer=0
        this.naklad = 0;
       
        this.mb = 0;
        this.msgs = w.msgs;
        this.origin = w.origin;
        if (w._err) this._err=w._err;
        else this._err={}

        this.nazwa = w.nazwa;
        this.miejsce = w.miejsce;
        this.opis = w.opis;
        this.raport = w.raport;
        this.uwagi = w.uwagi;
        this.dostepnosc = w.dostepnosc;
        this.w23_mat_wie_pap = w.w23_mat_wie_pap;
        this.w24_mat_wie_fol = w.w24_mat_wie_fol;
        this.w25_podklad_pap = w.w25_podklad_pap;
        this.w26_podklad_fol = w.w26_podklad_fol;
        this.w27_podklad_iml = w.w27_podklad_iml;
        this.w28_min_gr_podkl = w.w28_min_gr_podkl;
        this.w29_max_gr_podkl = w.w29_max_gr_podkl;
    
    }


    public static getKosztPolimeruPLN(w:IWykrojnik) {1
        const cm2 =  (w.szerokosc/10) * (w.uy*(w.y+w.y1)/10)
        const koszt_cm2PLN = 0.1;
        const koszt = cm2* koszt_cm2PLN; 
        return parseInt(koszt.toString());
    }

    public static getKosztBlachyWykrojnikaEUR(w:IWykrojnik) {
        const u = w.ux *w.uy;
        let koszt =  159;
        if (u <= 100) koszt = 159;
        if (u <= 40) koszt = 114;
        if (u <= 20) koszt = 80;

        if (w.ksztalt == 'N') koszt *= 1.2;

        koszt *= 1.1;
        return parseInt(koszt.toString());
    }



    public prepare(wp:IWykrojnikParams) {
          const w=this;
          
          w.ksztalt=wp.ksztalt;
          w.banda= this.round(0,w.szerokosc-w.x*w.ux - (w.x1*(w.ux-1)));
          w.x=this.round(1,w.x)
          w.y=this.round(1,w.y)
          w.x1=this.round(1,w.x1)
          w.y1=this.round(1,w.y1)
          w.banda=this.round(0,w.banda)
          const pow_uzytkowa = w.x*w.ux * w.y*w.uy
          const skok = 3.175;
          const pow_fakt = (w.szerokosc* w.zeby*skok)
          w.wykorzystanie=this.round(0,100*pow_uzytkowa/pow_fakt);
    //      if (p) {
    //        wykrojnik_ok(w, wp)
    //      }
      }
    
    private round(places:number,xx:number) {
        let x:number=0
        if (!xx) xx=0;
        if (xx) x=Number.parseFloat(parseFloat(xx.toString()).toFixed(places));
        return x;
    }
}
